import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IframeComponent } from './iframe/iframe.component';
import { NoHtmlPipe } from './noHtml/noHtml.pipe';
import { SafeHtmlPipe } from './safeHtml/safeHtml.pipe';
import { SafeUrlPipe } from './safeUrl/safeUrl.pipe';
import { StorageService } from './storage/storage.service';
import { BROWSER_STORAGE_SERVICE_TOKEN } from './storage/storage.service.interface';
import { StreamUrlPipe } from './streamUrl/streamUrl.pipe';

@NgModule({
  imports: [CommonModule],
  providers: [{ provide: BROWSER_STORAGE_SERVICE_TOKEN, useClass: StorageService }],
  exports: [IframeComponent, SafeHtmlPipe, NoHtmlPipe, SafeUrlPipe, StreamUrlPipe],
  declarations: [IframeComponent, SafeHtmlPipe, NoHtmlPipe, SafeUrlPipe, StreamUrlPipe],
})
export class BrowserModule {}
